import { render, staticRenderFns } from "./PagesDynamicToplistWidget.vue?vue&type=template&id=1996845e&"
import script from "./PagesDynamicToplistWidget.vue?vue&type=script&lang=js&"
export * from "./PagesDynamicToplistWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports